import { useLang } from '@/i18n';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const listA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776173/dd1.png',
        title: t('win3_a_title'),
        desc: t('win3_a_desc'),
        specList: [
            {
                title: t('win3_a_item1_t'),
                desc: t('win3_a_item1_b'),
            },
            {
                title: t('win3_a_item2_t'),
                desc: t('win3_a_item2_b'),
            },
            {
                title: t('win3_a_item3_t'),
                desc: t('win3_a_item3_b'),
            },
            {
                title: t('win3_a_item4_t'),
                desc: t('win3_a_item4_b'),
            },
            {
                title: t('win3_a_item5_t'),
                desc: t('win3_a_item5_b'),
            },
            {
                title: t('win3_a_item6_t'),
                desc: t('win3_a_item6_b'),
            },
            {
                title: t('win3_a_item7_t'),
                desc: t('win3_a_item7_b'),
            },
            {
                title: t('win3_a_item8_t'),
                desc: t('win3_a_item8_b'),
            },
            {
                title: t('win3_a_item9_t'),
                desc: t('win3_a_item9_b'),
            },
        ],
    };

    const listB = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776333/dd2.png',
        h5: '',
        title: t('win3_b_title'),
        desc: t('win3_b_desc'),
        specList: [
            {
                title: t('win3_b_item1_t'),
                desc: t('win3_b_item1_b'),
            },
            {
                title: t('win3_b_item2_t'),
                desc: t('win3_b_item2_b'),
            },
            {
                title: t('win3_b_item3_t'),
                desc: t('win3_b_item3_b'),
            },
            {
                title: t('win3_b_item4_t'),
                desc: t('win3_b_item4_b'),
            },
            {
                title: t('win3_b_item5_t'),
                desc: t('win3_b_item5_b'),
            },
            {
                title: t('win3_b_item6_t'),
                desc: t('win3_b_item6_b'),
            },
            {
                title: t('win3_b_item7_t'),
                desc: t('win3_b_item7_b'),
            },
            {
                title: t('win3_b_item8_t'),
                desc: t('win3_b_item8_b'),
            },
            {
                title: t('win3_b_item9_t'),
                desc: t('win3_b_item9_b'),
            },
        ],
    };

    const listC = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578776517/dd3.png',
        h5: '',
        title: t('win3_c_title'),
        desc: t('win3_c_desc'),
        specList: [
            {
                title: t('win3_c_item1_t'),
                desc: t('win3_c_item1_b'),
            },
            {
                title: t('win3_c_item2_t'),
                desc: t('win3_c_item2_b'),
            },
            {
                title: t('win3_c_item3_t'),
                desc: t('win3_c_item3_b'),
            },
            {
                title: t('win3_c_item4_t'),
                desc: t('win3_c_item4_b'),
            },
            {
                title: t('win3_c_item5_t'),
                desc: t('win3_c_item5_b'),
            },
            {
                title: t('win3_c_item6_t'),
                desc: t('win3_c_item6_b'),
            },
            {
                title: t('win3_c_item7_t'),
                desc: t('win3_c_item7_b'),
            },
            {
                title: t('win3_c_item8_t'),
                desc: t('win3_c_item8_b'),
            },
            {
                title: t('win3_c_item9_t'),
                desc: t('win3_c_item9_b'),
            },
        ],
    };

    const listAll = [listA, listB, listC];
    return (
        <div className={styles.Win3}>
            <EfTitle hasAnimation={false}>{t('win3_title')}</EfTitle>
            <EfProductCompareC items={listAll} theme="bg1" />
        </div>
    );
}
